import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  required,
  useGetList,
  useRecordContext,
} from 'react-admin';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Divider,
} from '@mui/material';
import {
  TableChart as TableIcon,
  LocationOn as ZoneIcon,
} from '@mui/icons-material';

const EditTitle = () => {
  const record = useRecordContext();
  return record ? `Editar Tabla "${record.tableName}"` : 'Editar Tabla';
};

const TablesEdit = () => {
  // Obtener lista de zonas
  const { data: zones, isLoading: zonesLoading } = useGetList('zones', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'zoneName', order: 'ASC' },
  });

  return (
    <Edit title={<EditTitle />} redirect='show' mutationMode='pessimistic'>
      <Box sx={{ padding: 3, maxWidth: 800, margin: '0 auto' }}>
        <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
          <CardContent>
            <Box display='flex' alignItems='center' mb={3}>
              <TableIcon sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
              <Box>
                <Typography variant='h5' component='h1' fontWeight='bold'>
                  Editar Tabla
                </Typography>
                <Typography variant='body2' color='text.secondary'>
                  Modifica la información de la tabla
                </Typography>
              </Box>
            </Box>

            <SimpleForm
              sx={{
                '& .RaSimpleForm-toolbar': {
                  marginTop: 3,
                  padding: 2,
                  backgroundColor: 'background.paper',
                  borderRadius: 2,
                  boxShadow: 2,
                },
              }}
            >
              <Grid container spacing={3}>
                {/* Información Principal */}
                <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      height: 'fit-content',
                      boxShadow: 2,
                      borderRadius: 2,
                      backgroundColor: 'background.default',
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <TableIcon color='primary' />
                        <Typography variant='h6' fontWeight='bold'>
                          Información de la Tabla
                        </Typography>
                      </Box>
                      <Divider sx={{ mb: 2 }} />

                      <TextInput
                        source='tableName'
                        label='Nombre de la Tabla'
                        validate={[required()]}
                        fullWidth
                        sx={{ mb: 2 }}
                        helperText='Nombre descriptivo para la tabla'
                      />
                    </CardContent>
                  </Card>
                </Grid>

                {/* Zona Asociada */}
                <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      height: 'fit-content',
                      boxShadow: 2,
                      borderRadius: 2,
                      backgroundColor: 'background.default',
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <ZoneIcon color='primary' />
                        <Typography variant='h6' fontWeight='bold'>
                          Zona Asociada
                        </Typography>
                      </Box>
                      <Divider sx={{ mb: 2 }} />

                      <ReferenceInput
                        source='zoneId'
                        reference='zones'
                        sort={{ field: 'zoneName', order: 'ASC' }}
                      >
                        <SelectInput
                          optionText='zoneName'
                          optionValue='id'
                          label='Zona'
                          validate={[required()]}
                          fullWidth
                          isLoading={zonesLoading}
                          helperText='Selecciona la zona a la que pertenece esta tabla'
                        />
                      </ReferenceInput>

                      <Box
                        sx={{
                          mt: 2,
                          p: 2,
                          backgroundColor: 'warning.light',
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant='body2' color='warning.dark'>
                          ⚠️ Cambiar la zona puede afectar las variables
                          existentes de la tabla
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </SimpleForm>
          </CardContent>
        </Card>
      </Box>
    </Edit>
  );
};

export default TablesEdit;
